import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styles from "./ChopNationNavbar.module.css";
import { FaShoppingCart, FaUser, FaBars, FaTimes, FaSignOutAlt } from "react-icons/fa";
import { useUser } from "../../context/UserContext";
import api from "../../api/axois";

const ChopNationNavbar = ({ cartCount, onOpenAuth }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const { user, setUser } = useUser();

  const isActive = (path) => location.pathname === path;

  const handleLogout = async () => {
    try {
      await api.post("/chopnation/logout");
    } catch (err) {
      // If we get a 401, it means the session was already invalid, which is fine for logout
      if (err.response?.status !== 401) {
        console.error("Logout failed", err);
      }
    } finally {
      setUser(null);
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      setMenuOpen(false);
    }
  };

  return (
    <nav className={styles.navbar}>
      <div className={styles.navContainer}>
        <Link to="/dining" className={styles.logo}>
          AURELIA<span>DINING</span>
        </Link>

        <div className={styles.mobileActions}>
           <Link to="/dining" className={styles.cartBtnMobile}>
            <FaShoppingCart />
            {cartCount > 0 && <span className={styles.badge}>{cartCount}</span>}
          </Link>
          <button className={styles.menuToggle} onClick={() => setMenuOpen(!menuOpen)}>
            {menuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>

        <ul className={`${styles.navLinks} ${menuOpen ? styles.show : ""}`}>
          <li><a href="#menu" onClick={() => setMenuOpen(false)}>Menu</a></li>
          <li><a href="#story" onClick={() => setMenuOpen(false)}>Our Story</a></li>
          <li><a href="#support" onClick={() => setMenuOpen(false)}>Support</a></li>
          {user ? (
            <li className={styles.mobileAuthItem}>
              <button
                className={styles.logoutBtn}
                onClick={handleLogout}
              >
                <FaSignOutAlt /> Logout
              </button>
            </li>
          ) : (
            <li className={styles.mobileAuthItem}>
              <button
                className={styles.logoutBtn}
                onClick={() => { setMenuOpen(false); onOpenAuth(); }}
              >
                <FaUser /> Login
              </button>
            </li>
          )}
        </ul>

        <div className={styles.desktopActions}>
          {user ? (
            <div className={styles.userProfile}>
              <button className={styles.userBtn} onClick={onOpenAuth}>
                <FaUser /> {user.first_name || user.name?.split(' ')[0] || "User"}
              </button>
              <button className={styles.logoutIcon} onClick={handleLogout} title="Logout">
                <FaSignOutAlt />
              </button>
            </div>
          ) : (
            <button className={styles.userBtn} onClick={onOpenAuth}>
              <FaUser /> Login
            </button>
          )}
          <div className={styles.cartBtn}>
            <FaShoppingCart />
            {cartCount > 0 && <span className={styles.badge}>{cartCount}</span>}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default ChopNationNavbar;
